import useApi from '../hooks/api.hook'


export default function usePartnerApi() {
    const { protectedRequest, publicRequest } = useApi()

    const twoFA = async (login, password) => {
        try { return await publicRequest('api/partner/2fa', {login, password}) }
        catch(error) { return null } 
    }

    const verify = async (login, password, code) => {
        try { return await publicRequest('api/partner/login', {login, password, code}) }
        catch(error) { return null } 
    }

    const get = async (id) => {
        try { return await protectedRequest('api/partner/get', {id}) }
        catch(error) { return null } 
    }

    const list = async () => {
        try { return await protectedRequest('api/partner/list') }
        catch(error) { return [] } 
    }

    const namesList = async () => {
        try { return await protectedRequest('api/partner/worker-list') }
        catch(error) { return [] } 
    }

    return { 
        get, 
        list,
        namesList,
        twoFA,
        verify
    }
}